/* eslint-disable global-require */
import queryStringParser from 'utils/queryStringParser';
import * as actionTypes from 'actions/actionTypes';
import messages from 'locales/messages';
import { changeLanguage } from 'actions/localization';
import { testLocalStorageSupport } from 'utils/localRepository';
import '@formatjs/intl-pluralrules/polyfill';

function getLocale() {
  const isLocalStorageSupported = testLocalStorageSupport();
  let savedLanguage;
  if (isLocalStorageSupported) {
    savedLanguage = localStorage.getItem(`${COUNTRY}.credit24.language`);
  }
  const langParameter = queryStringParser.parseAndMakeKeysLowerCase(location.search).lang;
  const navigatorLang = navigator.language || navigator.userLanguage;
  const browserLang = langParameter || savedLanguage || navigatorLang;

  let defaultLang = 'en';
  let langList = ['en'];

  if (COUNTRY === 'LV') {
    defaultLang = 'lv';
    langList = ['lv', 'ru', 'en'];
  } else if (COUNTRY === 'EE') {
    defaultLang = 'et';
    langList = ['et', 'ru', 'en'];
  } else if (COUNTRY === 'FI') {
    defaultLang = 'fi';
    langList = ['fi', 'en'];
  } else if (COUNTRY === 'MX') {
    defaultLang = 'es-MX';
    langList = ['es-MX', 'en'];
  } else if (COUNTRY === 'ES') {
    defaultLang = 'es';
    langList = ['es', 'en'];
  } else if (COUNTRY === 'PL') {
    defaultLang = 'pl';
    langList = ['pl', 'en'];
  } else if (COUNTRY === 'AU') {
    defaultLang = 'en-AU';
    langList = ['en-AU'];
  } else if (COUNTRY === 'LT') {
    defaultLang = 'lt';
    langList = ['en', 'lt'];
  } else if (COUNTRY === 'CZ') {
    defaultLang = 'cs';
    langList = ['en', 'cs'];
  }

  return langList.includes(browserLang) ? browserLang : defaultLang;
}

const locale = getLocale();
changeLanguage(locale);

const initialState = {
  locale,
  messages,
  areTranslationsLoading: false,
  isError: false,
  loadedLocales: [],
};

switch (COUNTRY) {
  case 'LV':
    require('@formatjs/intl-pluralrules/locale-data/en');
    require('@formatjs/intl-pluralrules/locale-data/lv');
    require('@formatjs/intl-pluralrules/locale-data/ru');
    break;
  case 'PL':
    require('@formatjs/intl-pluralrules/locale-data/en');
    require('@formatjs/intl-pluralrules/locale-data/pl');
    break;
  case 'FI':
    require('@formatjs/intl-pluralrules/locale-data/en');
    require('@formatjs/intl-pluralrules/locale-data/fi');
    break;
  case 'MX':
  case 'ES':
    require('@formatjs/intl-pluralrules/locale-data/en');
    require('@formatjs/intl-pluralrules/locale-data/es');
    break;
  case 'AU':
    require('@formatjs/intl-pluralrules/locale-data/en');
    break;
  case 'LT':
    require('@formatjs/intl-pluralrules/locale-data/en');
    require('@formatjs/intl-pluralrules/locale-data/lt');
    break;
  case 'CZ':
    require('@formatjs/intl-pluralrules/locale-data/en');
    require('@formatjs/intl-pluralrules/locale-data/cs');
    break;
  default:
    require('@formatjs/intl-pluralrules/locale-data/et');
    require('@formatjs/intl-pluralrules/locale-data/en');
    require('@formatjs/intl-pluralrules/locale-data/ru');
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CHANGE_LANGUAGE: {
      return {
        ...state,
        locale: action.data,
      };
    }
    case actionTypes.GET_TRANSLATIONS: {
      return {
        ...state,
        areTranslationsLoading: true,
      };
    }
    case actionTypes.GET_TRANSLATIONS_SUCCESS: {
      return {
        ...state,
        areTranslationsLoading: false,
        messages: {
          ...state.messages,
          [action.data]: {
            ...state.messages[action.data],
            ...action.result.data,
          },
        },
        loadedLocales: [...state.loadedLocales, action.data],
        isError: false,
      };
    }
    case actionTypes.GET_TRANSLATIONS_FAIL: {
      return {
        ...state,
        areTranslationsLoading: false,
        isError: true,
      };
    }
    default:
      return state;
  }
}
